// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./input-clear.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./input-clear-hover.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fileInput {
  visibility: hidden;
  padding: 0;
  display: none;
}

.Controlled.Input.FilePreview {
  height: 64px;
}
.Controlled.Input.FilePreview .Label {
  position: relative;
  width: 50%;
  text-overflow: ellipsis;
  height: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  display: inline-block;
  line-height: 67px;
  font-weight: 700;
  font-size: 12px;
  float: left;
  color: #002E33;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
}
.Controlled.Input.FilePreview .imageInputContainer {
  width: 50%;
  float: left;
}
.Controlled.Input.FilePreview .imageInputContainer .loadingEllipsis {
  width: 64px;
  position: absolute;
}
.Controlled.Input.FilePreview .imageInputContainer .Clear {
  left: calc(50% + 54px);
  height: 10px;
  top: -5px;
  position: absolute;
  width: 9px;
  background: #FFF url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center no-repeat;
  z-index: 4;
  background-size: 7px 7px;
  border-radius: 50%;
  padding: 3px;
  border: 1px solid #E8E9F0;
  cursor: pointer;
  visibility: hidden;
}
.Controlled.Input.FilePreview .imageInputContainer .Clear:hover {
  background: #FFF url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center no-repeat;
  background-size: 7px 7px;
}
.Controlled.Input.FilePreview .imageInputContainer .image:hover + .Clear,
.Controlled.Input.FilePreview .imageInputContainer .Clear:hover {
  visibility: visible;
}
.Controlled.Input.FilePreview .imageInputContainer .image {
  display: block;
  cursor: pointer;
  width: 62px;
  height: 62px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  font-size: 4em;
  -webkit-text-decoration: none;
  text-decoration: none;
  color: #697588;
  text-align: center;
  background-clip: content-box;
  -webkit-box-shadow: 1px 1px 6px #E8E9F0;
          box-shadow: 1px 1px 6px #E8E9F0;
  border-radius: 2px;
}
.Controlled.Input.FilePreview .imageInputContainer .image:hover:before {
  content: "+";
  width: 62px;
  height: 64px;
  position: absolute;
  top: -1px;
  background-color: #FFF;
  color: #002E33;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/ImageInput/ImageInput.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;AADF;;AAIA;EACE,YAAA;AADF;AAGE;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,cCpBW;EDqBX,gBAAA;EACA,mBAAA;EACA,eAAA;AADJ;AAIE;EACE,UAAA;EACA,WAAA;AAFJ;AAII;EACE,WAAA;EACA,kBAAA;AAFN;AAKI;EACE,sBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,yEAAA;EACA,UAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AAHN;AAKM;EACE,yEAAA;EACA,wBAAA;AAHR;AAOI;;EAEE,mBAAA;AALN;AAQI;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,6BAAA;EAAA,qBAAA;EACA,cCpBG;EDqBH,kBAAA;EACA,4BAAA;EACA,uCAAA;UAAA,+BAAA;EACA,kBAAA;AANN;AAQM;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,sBC7EA;ED8EA,cCpFO;EDqFP,cAAA;AANR","sourcesContent":["@import '../../../Global/Colors';\n\n.fileInput {\n  visibility: hidden;\n  padding: 0;\n  display: none;\n}\n\n.Controlled.Input.FilePreview {\n  height: 64px;\n\n  .Label {\n    position: relative;\n    width: 50%;\n    text-overflow: ellipsis;\n    height: 100%;\n    box-sizing: border-box;\n    display: inline-block;\n    line-height: 67px;\n    font-weight: 700;\n    font-size: 12px;\n    float: left;\n    color: $DeepSeaGreen;\n    overflow: hidden;\n    white-space: nowrap;\n    cursor: pointer;\n  }\n\n  .imageInputContainer {\n    width: 50%;\n    float: left;\n\n    .loadingEllipsis {\n      width: 64px;\n      position: absolute;\n    }\n\n    .Clear {\n      left: calc(50% + 54px);\n      height: 10px;\n      top: -5px;\n      position: absolute;\n      width: 9px;\n      background: $White url(./input-clear.svg) center no-repeat;\n      z-index: 4;\n      background-size: 7px 7px;\n      border-radius: 50%;\n      padding: 3px;\n      border: 1px solid $Gray30;\n      cursor: pointer;\n      visibility: hidden;\n\n      &:hover {\n        background: $White url(./input-clear-hover.svg) center no-repeat;\n        background-size: 7px 7px;\n      }\n    }\n\n    .image:hover+.Clear,\n    .Clear:hover {\n      visibility: visible;\n    }\n\n    .image {\n      display: block;\n      cursor: pointer;\n      width: 62px;\n      height: 62px;\n      background-size: contain;\n      background-repeat: no-repeat;\n      background-position: center;\n      font-size: 4em;\n      text-decoration: none;\n      color: $Gray90;\n      text-align: center;\n      background-clip: content-box;\n      box-shadow: 1px 1px 6px $Gray30;\n      border-radius: 2px;\n\n      &:hover:before {\n        content: '+';\n        width: 62px;\n        height: 64px;\n        position: absolute;\n        top: -1px;\n        background-color: $White;\n        color: $DeepSeaGreen;\n        display: block;\n      }\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
